import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import _ from "lodash";
import placeholderBackground from "../../../../assets/images/placeholder-background.png";

import { config } from "../../../../config";

const { SERVER_URL } = config;

const AddItemDrawer = ({
  history,
  userPoints,
  activeItem,
  setActiveItem,
  cart,
  setCart,
  setHasNoMail,
}) => {
  const [itemInCart, setItemInCart] = useState(null);

  const [quantity, setQuantity] = useState(0);
  const [maxQuantity, setMaxQuantity] = useState(0);
  const [subtotal, setSubtotal] = useState(0);

  const handleAddToCart = () => {
    let cloneCart = JSON.parse(JSON.stringify([...cart]));

    if (itemInCart) {
      let index = cloneCart.findIndex(
        (cartItem) => cartItem.item_id === activeItem.id
      );

      if (quantity > 0) {
        let newSubtotal = parseInt(activeItem.redeem_points) * quantity;

        cloneCart[index].quantity = quantity;
        cloneCart[index].subtotal = newSubtotal;
      } else {
        cloneCart = cloneCart.filter(
          (cartItem) => cartItem.item_id !== activeItem.id
        );
      }
    } else {
      cloneCart.push({
        item_id: activeItem.id,
        item: activeItem,
        quantity,
        subtotal,
      });
    }

    setCart(cloneCart);
    setActiveItem(false);

    if (cloneCart && cloneCart.length > 0) {
      cloneCart.map((cartItem) => {
        if (cartItem.item.mailing_cost <= 0) {
          setHasNoMail(true);
        }
      });
    }
  };

  useEffect(() => {
    !activeItem && setQuantity(0);
  }, [activeItem]);

  useEffect(() => {
    activeItem && setSubtotal(parseInt(activeItem.redeem_points) * quantity);
  }, [activeItem, quantity]);

  useEffect(() => {
    if (activeItem) {
      let cloneCart = JSON.parse(JSON.stringify([...cart]));
      let itemInCart = cloneCart.find(
        (cartItem) => cartItem.item_id === activeItem.id
      );

      if (itemInCart) {
        setItemInCart(itemInCart);
        setQuantity(itemInCart.quantity);
      } else {
        setItemInCart(null);
        setQuantity(0);
      }
    }

    localStorage.setItem("cart", JSON.stringify(cart));
  }, [activeItem, cart]);

  return (
    <Drawer
      anchor="bottom"
      classes={{ paper: "drawer" }}
      open={activeItem ? true : false}
      onClose={() => setActiveItem(null)}
    >
      <div className="container py-3">
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center ">
            <div
              onClick={() => history.push(`/rewards/item/${activeItem.id}`)}
              className="img-responsive"
              style={{
                position: "relative",
                background: `url(${
                  activeItem && activeItem.images.length > 0
                    ? `${SERVER_URL}/${activeItem.images[0].url}`
                    : placeholderBackground
                }) no-repeat center center`,
                backgroundSize: "cover",
                height: "75px",
                width: "75px",
              }}
            ></div>
            <div className="d-flex flex-column flex-grow-1 ml-3">
              <h6 className="p-0 m-0">{activeItem && activeItem.name}</h6>
              <div className="text-brand mt-1" style={{ fontSize: "0.8rem" }}>
                {activeItem && activeItem.type === "redeemable"
                  ? `${activeItem.redeem_points} POINTS`
                  : "FREE"}
              </div>
            </div>
          </div>
          {/* <div className="pt-2">
            {activeItem
              ? _.truncate(activeItem.description, { length: 100 })
              : ''}
          </div> */}
          <div className="py-2 my-2 d-flex flex-column border-bottom border-top">
            <div className="d-flex justify-content-between align-items-center">
              <label htmlFor="redeemItemQuantity" className="col-form-label">
                Quantity
              </label>
              <div className="input-group" style={{ width: "120px" }}>
                <div className="input-group-prepend">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    type="button"
                    id="minusItemQuantity"
                    onClick={() =>
                      quantity <= 0 ? setQuantity(0) : setQuantity(quantity - 1)
                    }
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                </div>
                <input
                  type="number"
                  readOnly={true}
                  className="form-control text-center bg-white"
                  value={quantity}
                  min={0}
                  max={activeItem && activeItem.free_threshold}
                  id="redeemItemQuantity"
                  name="redeemItemQuantity"
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    type="button"
                    id="plusItemQuantity"
                    onClick={() =>
                      ((activeItem && activeItem.free_threshold === 0) ||
                        (activeItem.free_threshold !== 0 &&
                          quantity < activeItem.free_threshold) ||
                        cart.total + subtotal < userPoints) &&
                      quantity < activeItem.quantity &&
                      setQuantity(quantity + 1)
                    }
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3">
              <h5>Total:</h5>
              <h5 className="text-brand">{subtotal} Points</h5>
            </div>
          </div>
          <button
            disabled={
              (!itemInCart && quantity === 0) ||
              (itemInCart && itemInCart.quantity === quantity)
            }
            className={`btn btn-design ${
              itemInCart && itemInCart.quantity > 0 && quantity === 0
                ? "btn-danger"
                : "btn-brand"
            }`}
            onClick={handleAddToCart}
          >
            {itemInCart && itemInCart.quantity > 0 && quantity === 0
              ? "Remove From Cart"
              : itemInCart && itemInCart.quantity > 0 && quantity > 0
              ? "Update Cart"
              : "Add To Cart"}
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default withRouter(AddItemDrawer);
